<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'pageset',
})
</script>
<template>
  <a-modal @ok="submit" v-model:open="openset"   title="页面内容" width="80%" :destroyOnClose="true">
  <div  style="min-height: 400px;overflow-y: auto;max-height:70vh;">
    <draggable :list="dataSource" itemKey="id" element="ul">
      <template #item="{ element,index }">
        <li>
      <a-card   class="box-shadow margin-bottom">
        <template #title>
          <a-badge :count="index+1"/>
          <span class="margin-lr">{{ element.name }}</span>
            <a-tooltip title="编辑组件">
              <a @click="editsctionset(element.id)" class="padding"><EditOutlined /></a>
              </a-tooltip>
              <a-tooltip title="预览组件">
              <a target="_blank" :href="'/pageview?sectionID='+element.id+'&pageID='+id+'&flag='+element.flag"><EyeOutlined /> </a>
              </a-tooltip>
        </template>
        <template #extra>
          <a-popconfirm title="确定要删除吗" @confirm="delItem(element,index)">
              <CloseOutlined />
          </a-popconfirm>
        </template>
        <a-row :gutter="20">

          <a-col :span="3">
            <span class="text-sm text-gray margin-right-sm">背景图</span>
            <uploadimg v-model:value="element.backgroundimg"></uploadimg>
          </a-col>
          <a-col :span="3">
            <span class="text-sm text-gray margin-right-sm">背景色</span>
            <colorpicker  v-model:value="element.background" ></colorpicker>
          </a-col>
          <a-col :span="3">
            <span class="text-sm text-gray margin-right-sm">文字色</span>
            <colorpicker v-model:value="element.color"></colorpicker>
          </a-col>
          <a-col :span="3">
            <a-tooltip>
            <span class="text-sm text-gray margin-right-sm"> 样式</span>
            </a-tooltip>
              <styleSelector  v-model:value="element.classname"></styleSelector>
          </a-col>
          <a-col :span="4">
            <a-tooltip title="每行显示多少列元素">
            <span class="text-sm text-gray margin-right-sm">列数</span>
             </a-tooltip>
            <a-input-number v-model:value="element.col" :min="2" :max="6"></a-input-number>
          </a-col>
          <a-col :span="4">
            <a-tooltip title="是否显示主标题">
            <span class="text-sm text-gray margin-right-sm">标题</span>
            </a-tooltip>
            <a-switch checked-children="显示" un-checked-children="隐藏" v-model:checked="element.showtitle" />
          </a-col>
           <a-col :span="4">
            <a-tooltip title="自动：不同屏幕宽度自适应且留白；全宽：全屏宽度">
            <span class="text-sm text-gray margin-right-sm">宽度</span>
            </a-tooltip>
            <a-switch checked-children="全宽" un-checked-children="自动" v-model:checked="element.fullwidth" />
          </a-col>
        </a-row>
      </a-card>
    </li>
    </template>
  </draggable>
  <div class="text-center padding">
    <a-button type="primary" :size="40" @click="add" >
      <PlusOutlined/>
    </a-button>
  </div>

  <sectionSelector ref="sections" @change="sectionChange"></sectionSelector>
  <a-drawer
      v-model:open="opensectionset" :destroyOnClose="true"
      title="组件编辑"
      width="80%"
      placement="right"
      @close="sectionContentChange"
    >
     <sectionset :id="sectionID"></sectionset>
  </a-drawer>
</div>
</a-modal>
</template>
<script setup name="pageset" lang="ts">
import { onMounted,defineProps,ref,defineExpose } from 'vue';
import {PlusOutlined,CaretRightOutlined,CloseOutlined,EditOutlined,EyeOutlined} from '@ant-design/icons-vue';
import api from '@/utils/http/service'
import styleSelector from  './styleselector.vue'
import sectionSelector from './sectionselector.vue'
import uploadimg from '@/components/lanseed/model/uploadimg.vue'
import colorpicker from '@/components/lanseed/model/colorpicker.vue'
import draggable from 'vuedraggable'
import sectionset from './sectionset.vue'


const openset=ref<Boolean>(false)
const opensectionset=ref<Boolean>(false)
const sectionID=ref<Number>(0)
const model=ref<Object>({})

const dataSource=ref<Array>([])
const id=ref<Number>(0)
const styles=ref()
const sections=ref()
const add=():void=>{
  sections.value.open({id:0,flag:''})
}
const sectionChange=(res)=>{
  let len=dataSource.value.length
  let list:Array=[]
  res.forEach(e=>{
    let v={
    id:0,pageID:id.value,name:e.text,classname:'default',backgroundimg:'',background:'',    orders:len,flag:null,showtitle:true,col:3,fullwidth:false
    }
    len++
    if(typeof(e.id)=='string'){
      v.flag=e.id
    }else if(typeof(e.id)=='number'){
      v.id=e.id
    }
    dataSource.value.push(v)
  })
}
const delItem=(item,i)=>{
  api.sitepage.delitem(id.value,item.id,item.flag).then(res=>{
    if(res.state==1){
        dataSource.value.splice(i,1)
    }
  })
}
const submit=()=>{
  let v={pageID:id.value,list:Object.assign([],dataSource.value)}

  v.list.forEach(e=>{
    e.showtitle=e.showtitle?1:0
    e.fullwidth=e.fullwidth?1:0
  })
  api.sitepage.submititem(v).then(res=>{
    if(res.state==1){
        openset.value=false
    }
  })
}
const open=(pageid:Number)=>{
  id.value=pageid
  api.sitepage.itemlist(pageid).then(res=>{
    res.data.forEach(e=>{
      e.showtitle=e.showtitle>0?true:false
      e.fullwidth=e.fullwidth>0?true:false
    })
    dataSource.value=res.data
    openset.value=true
  })
}
const openStyle=(item)=>{
  styles.value.open(item.classname)
}
const close=()=>{
  openset.value=false
}
const editsctionset=(id:Number)=>{
  sectionID.value=id
  opensectionset.value=true
}
const previcesctionset=(id:Number)=>{
  sectionID.value=id
  opensectionset.value=true
}
const sectionContentChange=(f:Object)=>{
  //关闭修改组件界面时，需要将界面上上的重新更新
   open(id.value)
}
defineExpose({
  open,close
})
</script>
<style>
  .ant-upload-select-picture-card{width:64px;height:64px;}
</style>
